import { Link } from "@mui/material";
import { useContext } from "react";
import { FieldProps, useRecordContext } from "react-admin";
import { useNavigate } from "react-router-dom";
import { OpenTabsContext } from "../OpenTabsContext";
import useNotify from "../unit/useNotify";

const CustomerIdLinkUserIdField = (_: FieldProps) => {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const { openGlobalTabs } = useContext(OpenTabsContext);
  const navigate = useNavigate();
  const record = useRecordContext();

  if (!record) {
    return null;
  }

  const handleClick = (id: any) => {
    if (openGlobalTabs.length >= 6) {
      if (openGlobalTabs.includes("customer-" + id + "-")) {
        navigate(`/userSummary/` + id);
      } else {
        errorNotify("Cannot open more than 6 tabs.");
        return false;
      }
    } else {
      navigate(`/userSummary/` + id);
    }
  };
  return (
    <Link
      component="span"
      onClick={() => handleClick(record.iUserId)}
      className="numericText"
      underline="none"
      sx={{
        cursor: "pointer",
        textDecoration: "none",
      }}
    >
      {record.iUserId}
    </Link>
  );
};

export default CustomerIdLinkUserIdField;
